import { frontendURL } from '../../../helper/URLHelper';

const IaComercialView = () => import('./IaComercialView.vue');
const IaComercialSettings = () => import('./IaComercialSettings.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ia-comercial'),
    name: 'ia_comercial_view',
    meta: {
      permissions: ['administrator'],
    },
    component: IaComercialView,
  },
  {
    path: frontendURL('accounts/:accountId/ia-comercial/configuracoes'),
    name: 'ia_comercial_settings',
    meta: {
      permissions: ['administrator'],
    },
    component: IaComercialSettings,
  },
];
